import React from 'react'
import Image from '../../../images/sellerpolicies/11.png'

const Packaging_guidelines = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Packaging guidelines </h2>
            <p>All sellers that are registered with KAAY must pack their orders in KAAY-branded packaging material.</p>
            <p>Sellers will follow KAAY packaging guidelines to ensure that the customers receive their orders in proper standardized packaging.</p>
            <p>Seller is allowed to use their own branded packaging material. But the seller is legally obligated to use the KAAY flyer as the outer final packaging material.</p>
            <p>In case of damage due to improper packing KAAY or the 3 PL services provider company will not be labile for any damages.</p>
        </div>
      </div>
    </div>
  )
}

export default Packaging_guidelines
